import IncidentForm from "../../../../components/Forms/incidentForm";
import { TabOptions } from "../../../../types/fieldInstance.interface";

const Statements = () => {
  return (
    <div>
      <IncidentForm tabTitle={TabOptions.Statements} />
    </div>
  );
};

export default Statements;
